import CatalogFragment from '@square/dashboard-items-data/serializers/connect/catalog-fragment';
export default class Data extends CatalogFragment {
  serialize(snapshot, options) {
    const json = super.serialize(snapshot, options);
    delete json.is_product_all_tokens_been_cascade_delete;
    delete json.line_item_types;
    delete json.match_custom_amounts;
    return json;
  }
}